// Pylon customer-portal embed.
//
// The portal lives on help.plivo.com — a custom domain that shares the console's root domain
// (plivo.com), so the iframe is same-site. Pylon's JWT-SSO chain self-authenticates using the
// user's existing console session (help.plivo.com -> cx.plivo.com/pylon/login ->
// graph.usepylon.com -> back to help.plivo.com), so no token handling is needed here.
//
// One prerequisite, set at the CloudFront edge (not in this repo): cx.plivo.com's CSP
// `frame-ancestors` must include 'self', so the console can frame its own /pylon/login step.

import { useEffect, useState } from 'react'
import { SuspenseLoader } from 'v2/shared/components/suspense-loader'

const PYLON_PORTAL_URL = 'https://help.plivo.com'

export const PylonPortal = () => {
  const [loaded, setLoaded] = useState(false)

  // The portal takes a few seconds to appear — it bounces through the JWT-SSO redirect chain
  // before rendering — during which a bare iframe is blank white and reads as broken. Show the
  // same Buddy loader the console uses until the iframe's load event fires. A timeout fallback
  // guarantees we never hang on the loader if that event is missed (e.g. a cached response).
  useEffect(() => {
    const fallback = setTimeout(() => setLoaded(true), 20000)
    return () => clearTimeout(fallback)
  }, [])

  return (
    <div className="relative flex h-full w-full">
      {!loaded && (
        <div className="absolute inset-0 z-10 bg-background">
          <SuspenseLoader text="Loading the support portal…" />
        </div>
      )}
      <iframe
        src={PYLON_PORTAL_URL}
        title="Support Portal"
        onLoad={() => setLoaded(true)}
        className="h-full w-full border-0"
        allow="clipboard-write"
      />
    </div>
  )
}
